import {FC, useEffect, useMemo, useRef, useState} from 'react'
import {
  fetchData,
  formatNumber,
  getEncryptedRoute,
  toasterrormsg,
  useMenuIdPermissions,
} from '../../../../reusable'
import {KTIcon} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import {Link, useLocation} from 'react-router-dom'
import {Tr} from '../../../../_metronic/i18n/Tr'

const InvoiceWiseVendorPaymentManagement: FC = () => {
  let t = Tr()
  const {menuId} = useMenuIdPermissions()

  const location = useLocation()
  const invoiceCode = (location.state as any)?.invoiceCode || ''
  const [paymentDetailList, setPaymentDetailList] = useState([])
  const [orgPaymentDetailList, setOrgPaymentDetailList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [totalRecords, setTotalRecords] = useState('') as any
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalInsayrRevenue, setTotalInsayrRevenue] = useState('')
  const [totalRevenue, setTotalRevenue] = useState('')
  const [totalBooking, setTotalBooking] = useState('') as any
  const [percentagePaid, setPercentagePaid] = useState('')

  //   Payment detail list api call
  const invoiceWiseListApiCall = async (limit1?: any, offset1?: any) => {
    var param: any = {
      invoiceCode: invoiceCode,
      limit: limit1,
      offset: offset1,
    }

    var res = await fetchData('admin/invoicecodewise', param)

    if (res.status == '200') {
      var data = res.data.data
      setPaymentDetailList(data)
      setOrgPaymentDetailList(data)
      setTotalRecords(res.data.totalRecord)
    } else {
      toasterrormsg(res.message)
    }
  }
  const invoiceWiseListTotalApiCall = async () => {
    var param: any = {
      invoiceCode: invoiceCode,
      limit: limit,
      offset: offset,
    }

    var res = await fetchData('admin/invoicecodewisetotal', param)

    if (res.status == '200') {
      var data = res.data
      setPercentagePaid(data.percentagePaid)
      setTotalInsayrRevenue(data.insayrRevenue)
      setTotalRevenue(data.totalRevenue)
      setTotalBooking(data.totalBookings)
    } else {
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const paymentDetailSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setPaymentDetailList(orgPaymentDetailList)
    } else {
      var tmp: any = orgPaymentDetailList.filter((item: any) => {
        return (
          (item.fullName != null &&
            item.fullName != '' &&
            String(item.fullName).toLocaleLowerCase().includes(text)) ||
          (item.period != null &&
            item.period != '' &&
            String(item.period).toLocaleLowerCase().includes(text)) ||
          (item.invoiceCreated != null &&
            item.invoiceCreated != '' &&
            String(item.invoiceCreated).toLocaleLowerCase().includes(text)) ||
          (item.totalRevenue != null &&
            item.totalRevenue != '' &&
            String(item.totalRevenue).toLocaleLowerCase().includes(text)) ||
          (item.bookingCount != null &&
            item.bookingCount != '' &&
            String(item.bookingCount).toLocaleLowerCase().includes(text)) ||
          (item.insayrRevenue != null &&
            item.insayrRevenue != '' &&
            String(item.insayrRevenue).toLocaleLowerCase().includes(text))
        )
      })
      setPaymentDetailList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }

  const formatDate2 = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: t('Property Name'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.fullName != '' ? (
              <div className='fw-bold fs-5 text-primary under text-decoration-underline cursor-pointer'>
                <Link
                  to={getEncryptedRoute('../invoicedatavendorwise/', {menuId:menuId})}
                  state={{
                    vendorId: row.vendorId,
                    categoryId: row.categoryId,
                    period: row.period,
                    actionId: row.actionId,
                  }}
                >
                  {row.fullName || '-'}
                </Link>
              </div>
            ) : (
              '-'
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.fullName),
        width: '200px',
      },

      {
        name: t('Service Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId == '1'
                ? t('Accommodation')
                : row.categoryId == '4'
                ? t('Space Rental')
                : row.categoryId == '5'
                ? t('Tour Package')
                : row.categoryId == '7'
                ? t('Car Rental')
                : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },
      {
        name: t('Period'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.period != '' ? row.period : '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.period),
        filter: true,
        width: '222px',
      },
      {
        name: t('Invoice Created'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.invoiceCreated != '' ? formatDate2(row.invoiceCreated) : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.invoiceCreated),
        filter: true,
        width: '222px',
      },

      {
        name: t('Number Of Bookings'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.bookingCount != '' ? row.bookingCount : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.bookingCount),
        filter: true,
        width: '222px',
      },
      {
        name: t('Total Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalRevenue != '' ? formatNumber(parseFloat(row.totalRevenue)) : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.totalRevenue),
        filter: true,
        width: '200px',
      },
      {
        name: t('Insayr Fee') + "(%)",
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrFee != '' ? row.insayrFee.toFixed(2) + '%' : '-'}
              {/* {row.percentagePaid == '' ? '-' : '12%'} */}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrFee),
        filter: true,
      },

      {
        name: t('Insayr Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrRevenue != '' ? formatNumber(parseFloat(row.insayrRevenue)) : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrRevenue),
        filter: true,
        width: '200px',
      },
      {
        name: t('Vendor Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalRevenue != '' && row.insayrRevenue != ''
                ? formatNumber(parseFloat(row.totalRevenue) - parseFloat(row.insayrRevenue))
                : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) =>
          Number(
            row.totalRevenue != '' && row.insayrRevenue != ''
              ? parseFloat(row.totalRevenue) - parseFloat(row.insayrRevenue)
              : '-'
          ),
        filter: true,
        width: '200px',
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
                {isNaN(row.paymentStatus) ? (
                  <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    Pay Now
                  </span>
                ) : (
                  '-'
                )}
              </label>
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrRevenue),
        filter: true,
        width: '150px',
      },
      {
        name: t('Payment Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>-</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrRevenue),
        filter: true,
        width: '200px',
      },
      {
        name: t('Payment Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
                {row.PaymentStatus == 'Pending' ? (
                  <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Pending')}
                  </span>
                ) : row.PaymentStatus == 'Paid' ? (
                  <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Paid')}
                  </span>
                ) : !isNaN(row.paymentStatus) ? (
                  row.paymentStatus + '% Paid'
                ) : (
                  '-'
                )}
              </label>
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.mainStatus),
        filter: true,
        width: '200px',
      },
    ],
    [t]
  )

  useEffect(() => {
    invoiceWiseListTotalApiCall()
    invoiceWiseListApiCall()
    sessionStorage.removeItem('vendor')
    document.title = 'Insayr | View Vendor Payment Management Details'
  }, [])

  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit) // Total pages based on API data only
    const newOffset = (newPage - 1) * limit
    setOffset(newOffset)
    invoiceWiseListApiCall(limit, newOffset)
  }

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage)
    invoiceWiseListApiCall(limit, offset)
  }

  const customRow = {
    fullName: '', // Unique identifier to differentiate it
    categoryId: '',
    period: '',
    invoiceCreated: '',
    bookingCount: Math.floor(totalBooking),
    totalRevenue: totalRevenue,
    insayrFee: '',
    insayrRevenue: totalInsayrRevenue,
    vendorRevenue: '',
    button: '',
    paymentStatus: percentagePaid,
  }

  // Combine hotelList with the custom row for display
  const dataWithCustomRow = useMemo(() => {
    // Always append the custom row to the current page's data
    return [...paymentDetailList, customRow]
  }, [paymentDetailList, percentagePaid, totalBooking, totalRevenue])
  return (
    <>
      <ToastContainer />
      <>
        <DataTable
          columns={column}
          data={paymentDetailList.length > 0 ? dataWithCustomRow : paymentDetailList}
          pagination
          paginationServer={true}
          subHeader={true}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={paymentDetailSearch} />
          }
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationTotalRows={totalRecords} // Only API records, custom row is added client-side
          paginationPerPage={limit}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </>
    </>
  )
}

export {InvoiceWiseVendorPaymentManagement}
